<ng-container>
	<obg-m-dialog-layout #dialog [hideClose]="true" [hideFooter]="true">
		<img obgImageContent="general.kyc-unverified-alert" alt="kyc-unverified-alert-image" />
		<h2 class="obg-m-verification-dialog-title">{{"kyc-verify-popup.title" | translate}}</h2>
		<p class="obg-m-verification-dialog-message" [innerHtml]="'kyc-verify-popup.message' | translate"></p>
		<div class="obg-m-verification-dialog-actions">
			<a
				class="redirect-button"
				mat-flat-button
				color="accent"
				[attr.test-id]="'verification-dialog-verify-button'"
				[obgRouteLink]="verificationRoute"
				(click)="closeDialog()"
			>
				{{ "kyc-verify-popup.verify" | translate }}
			</a>
			<a
				class="cancel-button"
				mat-stroked-button
				color="primary"
				[attr.test-id]="'verification-dialog-cancel-button'"
				(click)="closeDialog()"
			>
				{{ "general.cancel" | translate }}
			</a>
		</div>
	</obg-m-dialog-layout>
</ng-container>
